import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IFontProps {
  opacityValue?: string;
  rotationValue?: string;
  shapeType?: string;
  maxHeightValue?: string;
}

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 10px 10px 10px;
  box-sizing: border-box;
`;
export const RootBody = styled.div`
  display: flex;
  flex-direction: column;  
  box-sizing: border-box;  
  overflow:auto;
`;

export const SelectedItemContainer = styled.div`
  display: block;
  width: 100%;
  align-items: center;
`;

export const SearchContainer = styled.div`
  max-width: 281px;
  width: auto;
  display:inline-block;
  border-radius: 5px;
  box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px rgba(130, 130, 130, 0.5);
  background-color: #ffffff;
  position:relative;  
`;


export const FilterContainer = styled.div`
  display:inline-block;
`;

export const ButtonFilter = styled.button`
  height: 30px;
  font-size: 16px;
  text-align: left;
  color: ${C.LIGHT_GRAY};  
  border: unset;
  border-left: 1px solid ${C.LIGHT_GRAY};
  display:inline-block;
  background-color: #ffffff;
  cursor: pointer;
  margin: 0px 0px 0px 10px;
  &:hover, &:focus {
    color: ${C.DARK_GRAY};
    background-color: #f5f5f5;
    border-radius: 5px;
  } 
  &:focus {
      outline: none;
  }
`







export const HelpText = styled.div`
  font-family: Roboto;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
  padding: 0px 0px 5px 0px;
`;


export const ShapesContainer = styled.div`
  display:flex;
  flex-wrap:wrap;
`;

export const ShapeContainer = styled.div`
   padding: 7px;   
`;

export const ShapeVerticalContainer = styled.div`
   padding: 14px;   
`;

export const ImgShape = styled.img`
   max-width: 100%;
   max-height: 100%;
   object-fit: contain;
`;



export const DragShapeContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  background-color:transparent;  
  transform: translate(0, 0);
  padding:2px;
  cursor:pointer;
`;
